// extracted by mini-css-extract-plugin
module.exports = {"Dropdowns":"Dropdowns_Dropdowns__eaAlJ"};